import React from "react";

type RedPencilProps = {
  /** Defaults to primary red; use e.g. `text-white` on dark backgrounds. */
  className?: string;
};

const RedPencil: React.FC<RedPencilProps> = ({ className = "h-full w-full" }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.60036 2.08133C10.7478 0.931873 12.6082 0.931874 13.7557 2.08133C14.9031 3.23079 14.9031 5.09443 13.7557 6.24389L13.2065 6.79405L9.05116 2.63149L9.60036 2.08133ZM3.64749 15.8334H0V12.1795V11.7397L0.0392423 11.7004L0.0264066 11.6876L1.3518 10.3599L1.35268 10.3607L8.42972 3.27137L12.524 7.37277L5.56255 14.3463L5.56263 14.3464L4.36947 15.5417L4.3736 15.5458L4.08653 15.8334H3.64748L3.64749 15.8334ZM2.46543 14.6493L2.44985 14.6337L2.50237 13.3058L1.18206 13.3582V12.3641L2.13522 11.4092L4.42681 13.7048L3.48131 14.652L3.47862 14.6493H2.46543ZM2.84427 10.7606L8.51231 5.08271L8.88779 5.45885L3.21975 11.1368L2.84427 10.7606Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RedPencil;
